import cx from 'classnames';
import React, { useMemo } from 'react';
import { useCountriesList } from '../hooks/use-countries-list.js';
import { InlineDropdown, toValue } from '../index.js';
const CountryPhoneLabel = ({ country, long }) => {
    return (React.createElement("span", { className: cx('tds-country-phone-label', { 'tds-country-phone-label--long': long }) },
        React.createElement("span", { className: "tds-country-code" }, country.code),
        React.createElement("span", null,
            long && React.createElement("span", null, country.name),
            " +",
            country.phone)));
};
const stringLabel = ({ country }) => `${country.code} +${country.phone}`;
export const PhoneTooltip = ({ country: externalCountry, enabledCountries, locale = 'en-US', onCountrySelect, open, ...rest }) => {
    const { countries, defaultCountry } = useCountriesList(locale, enabledCountries);
    // use default in place of external state if needed
    const country = externalCountry || defaultCountry;
    const options = useMemo(() => {
        return [
            // First render default
            {
                fullLabel: React.createElement(CountryPhoneLabel, { country: country, long: true }),
                label: stringLabel({ country }),
                shortLabel: React.createElement(CountryPhoneLabel, { country: country }),
                value: country.code,
            },
            // Then all countries
            ...Object.keys(countries)
                .filter((code) => code !== country.code) // remove default country to avoid duplicates
                .map((code) => ({
                fullLabel: React.createElement(CountryPhoneLabel, { country: countries[code], long: true }),
                label: stringLabel({ country: countries[code] }),
                shortLabel: React.createElement(CountryPhoneLabel, { country: countries[code] }),
                value: code,
            }))
                .sort((a, b) => { var _a; return (_a = a === null || a === void 0 ? void 0 : a.value) === null || _a === void 0 ? void 0 : _a.localeCompare(b === null || b === void 0 ? void 0 : b.value); }),
        ];
    }, [countries, country]);
    return (React.createElement(InlineDropdown, { id: 'country', onOptionSelect: (option) => onCountrySelect(countries[`${toValue(option)}`]), open: open, options: options, selected: country ? country.code : options[0].label, visuallySelected: country ? `${country.code} +${country.phone}` : options[0].label, ...rest }));
};
